define.alias("shared/components/shared/app-footer", "preview-grid/components/shared/app-footer");